import UIkit from '../../node_modules/uikit/dist/js/uikit-core';
import Notification from '../../node_modules/uikit/src/js/components/notification';
import Tooltip from '../../node_modules/uikit/src/js/components/tooltip';
import Icons from '../../node_modules/uikit/dist/js/uikit-icons';

UIkit.component('notification', Notification);
UIkit.component('tooltip', Tooltip);
UIkit.use(Icons);

export default UIkit;
